import { observer } from 'mobx-react';
import * as React from 'react'
interface ErrorBoundaryState {
    hasError: boolean;
    error: any;
    errorInfo: any;
}

interface PropsErrorBoundary {
    children: any;
}


class ErrorBoundary extends React.Component<PropsErrorBoundary, ErrorBoundaryState> {

    constructor(props) {
        super(props);
        this.state = { hasError: false, error: '', errorInfo: '' };
    }

    static getDerivedStateFromError(_error) {
        return { hasError: true };
    }

    //TODO: passar para um serviço no backend?
    componentDidCatch(error, errorInfo) {
        this.setState({ error, errorInfo });
    }

    render() {
        if (this.state.hasError) {
            return (
                <div>
                    <h1>Erro inesperado</h1>
                    <div>
                        <p>
                            {this.state.error.message}
                        </p>
                        <div dangerouslySetInnerHTML={{ __html: this.state.errorInfo ? this.state.errorInfo.componentStack.split(' in ').join('</br> in ') : '' }}>

                        </div>
                    </div>
                </div>
            );
        }

        return <>{this.props.children}</>;
    }
}

export default observer(ErrorBoundary);